import { Layout as LayoutAnt } from "antd";
import styled, { css, keyframes } from "styled-components";

import { SingleOrderContainer } from "modules/Order/routes/SingleOrder/styles";
import { CourseLandingPageContainer } from "pages/[tenant]/courses/modules/CourseLandingPage/styles";

import { InvalidTokenWarningContainer } from "pages/[tenant]/401/styles";
import { Custom404Container } from "pages/[tenant]/[...404]/styles";
import { AccountPageContainer } from "pages/[tenant]/account/components/template/Wrapper/styles";
import { AuthenticationPageContainer } from "pages/[tenant]/authentication/styles";
import {
  BillboardPageContainer,
  BillboardPageContent,
} from "pages/[tenant]/browse/components/BillboardPage/styles";
import { CollectionCentralizer } from "pages/[tenant]/collections/components/SingleCollection/styles";
import { CollectionsCentralizer } from "pages/[tenant]/collections/styles";
import { ConfirmPageContainer } from "pages/[tenant]/confirm/styles";
import { LessonContentContainer } from "pages/[tenant]/courses/[course_slug]/[module_slug]/[lesson_slug]/components/Content/styles";
import { CoursesContainer } from "pages/[tenant]/courses/styles";
import { SpotlightsContainer } from "pages/[tenant]/dashboard/styles";
import { ErrorPageContainer } from "pages/[tenant]/error/styles";
import { FeedPageContainer } from "pages/[tenant]/feed/styles";
import { FirstAccessContainer } from "pages/[tenant]/first-access/styles";
import { ImersiveLessonPageContainer } from "pages/[tenant]/g/[group_slug]/classwork/[topic_slug]/[activitie_slug]/components/templates/ImersiveLessonPage/styles";
import { ClassworkPageContainer } from "pages/[tenant]/g/[group_slug]/classwork/components/templates/ClassworkPage/styles";
import { ClassworkPageGridContainer } from "pages/[tenant]/g/[group_slug]/classwork/components/templates/ClassworkPageGrid/styles";
import { ClassworkPageImersiveLayoutLoadingSkeletonContainer } from "pages/[tenant]/g/[group_slug]/classwork/components/templates/ClassworkPageImersiveLayout/LoadingSkeleton/styles";
import { ClassworkPageImersiveLayoutPageContainer } from "pages/[tenant]/g/[group_slug]/classwork/components/templates/ClassworkPageImersiveLayout/styles";
import { GroupCommunityPageTemplateContainer } from "pages/[tenant]/g/[group_slug]/community/components/templates/GroupCommunityPageTemplate/styles";
import { MissionPageContainer } from "pages/[tenant]/g/[group_slug]/missions/components/template/MissionsPage/styles";
import { RankingPageContainer } from "pages/[tenant]/g/[group_slug]/ranking/components/templates/RankingPage/styles";
import { GroupPageIndexContainer } from "pages/[tenant]/g/components/GroupPage/styles";
import { MediaContainer } from "pages/[tenant]/media/styles";
import { MyOrdersContainer } from "pages/[tenant]/orders/styles";
import { AffiliatePageWithoutProviderContainer } from "pages/[tenant]/promoter/[affiliate_uuid]/styles";
import { ResetPasswordPageContainer } from "pages/[tenant]/reset/styles";
import { SearchPageContainer } from "pages/[tenant]/search/styles";
import { CommunitiesContainer } from "pages/[tenant]/social/routes/CommunityList/styles";
import { CommunityTopicListContainer } from "pages/[tenant]/social/routes/CommunityTopicList/styles";
import { SingleTopicPageContainer } from "pages/[tenant]/social/routes/SingleTopic/styles";
import { TrailPageContainer } from "pages/[tenant]/trail/[trail_id]/components/organisms/TrailPage/styles";
import { UserProfileContainer } from "pages/[tenant]/user/[username]/styles";

import { PageLoaderContainer } from "shared/components/atoms/PageLoader/styles";
import { MenusListContainer } from "shared/providers/Layout/components/NewTopBar/components/atoms/MenusList/styles";
import { SideOptionsContainer } from "shared/providers/Layout/components/NewTopBar/styles";
import { EnsinioFooterBrandingContainer } from "shared/providers/Layout/components/atoms/EnsinioFooterBranding/styles";
import { PageErrorBoundaryContainer } from "shared/providers/PageErrorBoundary/styles";

import { ConsoleAnamnesePageContainer } from "@Console/anamnese/answers/styles";
import { ConsoleAnamneseQuestionnairesPageContainer } from "@Console/anamnese/questions/styles";
import { BillboardContainer } from "@Console/billboard/styles";
import { ConsoleCampaignTemplateTableContainer } from "@Console/campaign-templates/components/organisms/ConsoleCampaignTemplateTable/styles";
import { ConsoleCommentsTemplateContainer } from "@Console/comments/components/templates/ConsoleCommentsTemplate/styles";
import { ContainerAffiliateProgram } from "@Console/commissioning/Content/styles";
import { OptionsContainer } from "@Console/components/atoms/Options/styles";
import { ContainerAlertMyDocuments } from "@Console/components/molecules/AlertMyDocuments/styles";
import { ConsolePageSideBarContainer } from "@Console/components/organisms/ConsolePageSideBar/styles";
import { UnpublishedPlatformContainer } from "@Console/components/templates/UnpublishedPlatform/styles";
import { ConsoleEmailHistoryTableContainer } from "@Console/email-history/components/organisms/ConsoleEmailHistoryTable/styles";
import { ConsoleEmailTemplateTableContainer } from "@Console/email-templates/components/organisms/ConsoleEmailTemplateTable/styles";
import { GamificationDashTemplateContainer } from "@Console/gamification-dash/components/templates/GamificationDashTemplate/styles";
import { ConsoleGroupContentPageContainer } from "@Console/groups/[group_slug]/content/styles";
import { ConsoleGroupMembersPageContainer } from "@Console/groups/[group_slug]/members/styles";
import { ConsoleGroupModerationHeaderContainer } from "@Console/groups/[group_slug]/moderation/components/molecules/ConsoleGroupModerationHeader/styles";
import { ConsoleGroupModerationPageContainer } from "@Console/groups/[group_slug]/moderation/styles";
import { GroupOverviewContainer } from "@Console/groups/[group_slug]/overview/components/templates/GroupOverview/styles";
import { ConsoleGroupSalesPageContainer } from "@Console/groups/[group_slug]/sales/styles";
import { HelpDeskRequestsCompletedTableSectionContainer } from "@Console/help-desk/components/organisms/HelpDeskRequestsCompletedTableSection/styles";
import { HelpDeskWaitingAgentTableSectionContainer } from "@Console/help-desk/components/organisms/HelpDeskWaitingAgentTableSection/styles";
import { HelpDeskWaitingCustomerTableSectionContainer } from "@Console/help-desk/components/organisms/HelpDeskWaitingCustomerTableSection/styles";
import { ConsoleBatchImportContainer } from "@Console/imports/components/templates/ConsoleBatchImportTemplate/styles";
import { ConsoleOrganizationPageContainer } from "@Console/organizations/[organization_id]/styles";
import { ConsoleOrganizationsPageContainer } from "@Console/organizations/styles";
import { ConsolePerformancePageContainer } from "@Console/performance/styles";
import { TrackingPixelContainer } from "@Console/pixel/components/TrackingPixel/styles";
import { ConsoleSmartInstallmentTableContainer } from "@Console/smart-installment/components/organisms/ConsoleSmartInstallmentTable/styles";
import { ContainerStatementContent } from "@Console/statement/components/templates/StatementContent/styles";
import { DashboardSubscriptionTableSectionContainer } from "@Console/subscription-dashboard/components/organisms/DashboardSubscriptionTableSection/styles";
import { ConsoleTaskTemplateContainer } from "@Console/tasks/components/templates/ConsoleTaskTemplate/styles";
import { ContainerTransactionContent } from "@Console/transactions/Content/styles";
import { ContentStatisticPageTemplate } from "@Console/user-activity/components/templates/InitialStatisticPageTemplate/styles";
import { TopBarActionsContainer } from "@Console/users/[user_id]/components/molecules/TopBarActions/styles";
import { USerGroupsSectionContainer } from "@Console/users/[user_id]/components/organisms/UserGroupsSection/styles";
import { UserMetricsSectionContainer } from "@Console/users/[user_id]/components/organisms/UserMetricsSection/styles";
import { UserPaymentSectionContainer } from "@Console/users/[user_id]/components/organisms/UserPaymentSection/styles";
import { ConsoleActiveUsersPageContainer } from "@Console/users/active/styles";
import { ConsoleDisabledUsersPageContainer } from "@Console/users/disabled/styles";
import { ConsoleUserPageContainer } from "@Console/users/styles";
import { WebhookContainer } from "@Console/webhooks/content/styles";

export const AppLayoutContainer = styled.div`
  height: 100%;

  .app-layout {
    height: 100%;
  }

  :has(${BillboardPageContainer}) {
    height: initial;
  }

  .ant-btn-primary,
  .ant-btn-primary:is(:hover, :focus) {
    background-color: ${({ theme }) => theme.colors.primary} !important;
    color: ${({ theme }) => theme.colors.btnTextColor} !important;
    border: none;

    span {
      color: ${({ theme }) => theme.colors.btnTextColor} !important;
    }
  }
  && {
    div.sweet-alert {
      span {
        z-index: 5 !important;
      }

      h3,
      p {
        color: ${({ theme }) => theme.colors.textColor} !important;
        text-shadow: 1px 1px 25px rgba(0, 0, 0, 0.8) !important;
      }

      &,
      div {
        background-color: ${(props) =>
          props.theme.colors.modalBackgroundColor} !important;
      }

      a {
        border-color: transparent !important;
        box-shadow: none !important;
      }
    }
  }
`;

interface IContentProps {
  $isPaymentRoute: boolean;
  $sidebarIsRendered: boolean;
  $isInConsolePage: boolean;
  $shouldShowConsolePageSideBar: boolean;
  $shouldExpandConsolePageGrid: boolean;
  $shouldShowInternalModulePageSidebar: boolean;
}

const loadingAnimation = keyframes`
from {
  transform: rotate(0);
}

to {

  transform: rotate(360deg);
}
`;

export const AppLayoutContent = styled(LayoutAnt.Content)<IContentProps>`
  height: 100%;

  background: ${({ theme }) =>
    theme.mode !== "dark" ? theme.colors.backgroundColor : "#181818"};

  :has(${ErrorPageContainer}) {
    padding: 4rem 0px 0px 0px !important;

    .main-content-wrapper {
      padding: 2rem 2rem 0 !important;
    }
  }

  :has(${ContainerAlertMyDocuments}) {
    ${TopBarActionsContainer} {
      position: initial;
    }
  }

  :has(${SearchPageContainer}) {
    padding: 4rem 0;

    background-color: ${({ theme }) =>
      theme.mode === "dark" ? "#0B0A0D" : "#f2f2f2"};

    @media (max-width: 850px) {
      padding-top: 0;
    }
  }

  :has(
      ${ConsoleOrganizationsPageContainer},
        ${ConsoleOrganizationPageContainer},
        ${ContentStatisticPageTemplate},
        ${ConsoleCommentsTemplateContainer},
        ${ConsoleTaskTemplateContainer},
        ${ConsoleAnamneseQuestionnairesPageContainer},
        ${ConsoleAnamnesePageContainer},
        ${GroupOverviewContainer},
        ${ConsoleEmailTemplateTableContainer},
        ${ConsoleEmailHistoryTableContainer},
        ${WebhookContainer},
        ${ContainerTransactionContent},
        ${ContainerStatementContent},
        ${USerGroupsSectionContainer},
        ${UserPaymentSectionContainer},
        ${UserMetricsSectionContainer},
        ${GamificationDashTemplateContainer},
        ${ConsoleCampaignTemplateTableContainer}
        ${ConsolePerformancePageContainer},
        ${ConsoleUserPageContainer},
        ${ConsoleDisabledUsersPageContainer},
        ${ConsoleActiveUsersPageContainer},
        ${ConsoleSmartInstallmentTableContainer},
        ${ConsoleBatchImportContainer},
        ${ConsoleBatchImportContainer},
        ${ContainerAffiliateProgram},
        ${HelpDeskWaitingAgentTableSectionContainer},
        ${HelpDeskWaitingCustomerTableSectionContainer},
        ${HelpDeskRequestsCompletedTableSectionContainer},
        ${ConsoleGroupModerationPageContainer},
        ${ConsoleGroupContentPageContainer},
        ${ConsoleGroupModerationHeaderContainer},
        ${ConsoleGroupSalesPageContainer},
        ${DashboardSubscriptionTableSectionContainer},
        ${ConsoleGroupModerationHeaderContainer},
        ${ConsoleGroupMembersPageContainer},
        ${TrackingPixelContainer}
    ) {
    #admin-console-wrapper {
      overflow: auto;
    }
  }

  ${({
    $isInConsolePage,
    $shouldShowConsolePageSideBar,
    $shouldExpandConsolePageGrid,
    $shouldShowInternalModulePageSidebar,
    theme,
  }) =>
    $isInConsolePage &&
    css`
      padding: 0 !important;
      overflow-y: scroll;

      div.main-content-wrapper {
        display: grid;
        background-color: ${theme.console.backgroundColor};

        position: sticky;
        top: 0;

        ${$shouldShowConsolePageSideBar &&
        css`
          grid-template-columns: ${$shouldExpandConsolePageGrid
            ? "60px 230px 1fr"
            : "60px 1fr"};
        `}

        :has(${ContainerAlertMyDocuments}) {
          grid-template-rows: 88px 1fr;
        }

        ${$shouldShowInternalModulePageSidebar &&
        css`
          grid-template-columns: ${$shouldShowInternalModulePageSidebar
            ? "60px 230px minmax(230px, 23vw) 1fr"
            : "60px 1fr"};
        `}

        .loader {
          animation: ${loadingAnimation} 0.7s linear infinite;
        }

        @media (max-width: 850px) {
          ${$shouldShowConsolePageSideBar &&
          css`
            grid-template-columns: 1fr;

            padding: 6.5rem 0 4rem 0 !important;
          `}
        }

        :has(${PageErrorBoundaryContainer}) {
          ${PageErrorBoundaryContainer} {
            grid-column: 1/-1;
          }

          :has(${ConsolePageSideBarContainer} ~ ${OptionsContainer}) {
            ${PageErrorBoundaryContainer} {
              grid-column: 3/-1;
            }
          }

          :has(${ConsolePageSideBarContainer} ~ ${PageErrorBoundaryContainer}) {
            grid-column: 2/-1;
          }
        }
      }
    `}

  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  :has(${GroupPageIndexContainer}) {
    overflow-x: initial;
  }

  @media (max-width: 850px) {
    margin-top: 0px;
  }

  .main-content-wrapper {
    flex: 1 1;

    :has(${BillboardContainer}) {
      background-color: ${({ theme }) => theme.groups.backgroundModeration};
    }

    :has(
        ${ClassworkPageImersiveLayoutPageContainer},
          ${ImersiveLessonPageContainer},
          ${GroupCommunityPageTemplateContainer},
          ${ClassworkPageImersiveLayoutLoadingSkeletonContainer}
      ) {
      transition: 0.3s all;

      background-color: ${({ theme }) =>
        theme.mode === "dark" ? "black" : "#F6F6FC"};
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      color: ${({ theme }) => theme.colors.textColor};
    }
  }

  @media screen and (max-width: 990px) {
    ${(props) =>
      props.$isPaymentRoute
        ? css`
            padding: 3rem 0 0;
          `
        : css`
            padding: 4rem 0px 0px;
          `}
  }

  :has(${BillboardPageContent}) {
    ${EnsinioFooterBrandingContainer} {
      background-color: #010101;
      color: white;

      svg path {
        fill: white;
      }
    }
  }

  :has(${Custom404Container}) {
    ${EnsinioFooterBrandingContainer} {
      background-color: ${({ theme }) => theme.groups.backgroundColor};
    }
  }

  :has(
      ${GroupCommunityPageTemplateContainer},
        ${ClassworkPageImersiveLayoutPageContainer}
    ) {
    ${EnsinioFooterBrandingContainer} {
      background-color: ${({ theme }) =>
        theme.mode === "dark" ? "black" : "#F6F6FC"};
    }
  }

  :has(${ClassworkPageGridContainer}, ${ClassworkPageContainer}) {
    ${EnsinioFooterBrandingContainer} {
      background-color: ${({ theme }) => theme.classwork.backgroundColor};
    }
  }

  :has(${TrailPageContainer}) {
    ${EnsinioFooterBrandingContainer} {
      background-color: ${({ theme }) => theme.trails.backgroundColor};
    }
  }

  :has(${MissionPageContainer}) {
    ${EnsinioFooterBrandingContainer} {
      background-color: ${({ theme }) =>
        theme.groups.gamification.pageBackgroundColor};
    }
  }

  :has(${ClassworkPageContainer}) {
    ::-webkit-scrollbar {
      display: none;
    }
  }

  :has(
      ${RankingPageContainer},
        ${Custom404Container},
        ${InvalidTokenWarningContainer},
        ${SearchPageContainer},
        ${AccountPageContainer},
        ${MyOrdersContainer},
        ${SingleOrderContainer},
        ${UserProfileContainer},
        ${SpotlightsContainer},
        ${CourseLandingPageContainer},
        ${LessonContentContainer},
        ${MediaContainer},
        ${CollectionsCentralizer},
        ${CollectionCentralizer},
        ${CoursesContainer},
        ${CommunitiesContainer},
        ${CommunityTopicListContainer},
        ${SingleTopicPageContainer},
        ${ResetPasswordPageContainer},
        ${ConfirmPageContainer},
        ${AuthenticationPageContainer},
        ${FirstAccessContainer},
        ${AffiliatePageWithoutProviderContainer},
        ${FeedPageContainer},
    ) {
    ${EnsinioFooterBrandingContainer} {
      background: transparent;
    }
  }
`;

interface ILayoutProps {
  $isInConsolePage?: boolean;
  $isInCheckoutPage?: boolean;
}

export const Layout = styled(LayoutAnt)<ILayoutProps>`
  :has(${UnpublishedPlatformContainer}) {
    background-color: black !important;
  }

  :has(${BillboardPageContainer}) {
    background-color: ${({ theme }) => theme.groups.backgroundModeration};
  }

  ${({ theme }) =>
    theme.mode === "light" &&
    css`
      :has(${PageLoaderContainer}) {
        ${SideOptionsContainer} > ${MenusListContainer} {
          a,
          button {
            color: black;
          }
        }
      }
    `}

  @media (max-width: 768px) {
    ${({ $isInConsolePage }) =>
      !$isInConsolePage &&
      css`
        margin-bottom: 4rem;
      `}
  }

  ${({ $isInCheckoutPage }) =>
    $isInCheckoutPage &&
    css`
      margin-bottom: 0 !important;
    `}
`;
